import defaultReducer from "./defaultReducer";

export default defaultReducer('PASSWORD_MODAL', { visible: false, header: '', message: '', onConfirm: () => {} })